/** Locale prefixes that have generated compare-page HTML. */
export const SEO_PATH_LOCALES = ['es', 'fr', 'pt-br'];

export const SEO_PAGE_SLUGS = [
  '/alternatives/candy-ai',
  '/alternatives/character-ai',
  '/alternatives/crushon',
  '/best-ai-visual-novel',
  '/nsfw-ai-chatbot',
  '/ai-chatbot',
];

const PATH_LOCALE_TO_DISPLAY = {
  es: 'es',
  fr: 'fr',
  'pt-br': 'pt-BR',
};

const normalizePathname = (pathname) => {
  if (!pathname) return '/';
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed || '/';
};

export const seoPathPrefixFromPathname = (pathname) => {
  const parts = normalizePathname(pathname).split('/').filter(Boolean);
  const head = parts[0]?.toLowerCase();
  if (head && SEO_PATH_LOCALES.includes(head)) return head;
  return '';
};

export const stripSeoLocalePrefix = (pathname) => {
  const normalized = normalizePathname(pathname);
  const prefix = seoPathPrefixFromPathname(normalized);
  if (!prefix) return normalized;
  const rest = normalized.slice(prefix.length + 1);
  return rest || '/';
};

export const isSeoComparePath = (pathname) =>
  SEO_PAGE_SLUGS.includes(stripSeoLocalePrefix(pathname));

export const displayLanguageFromSeoPath = (pathname) => {
  const prefix = seoPathPrefixFromPathname(pathname);
  return prefix ? PATH_LOCALE_TO_DISPLAY[prefix] : null;
};

export const pathPrefixForDisplayLanguage = (language) => {
  if (language === 'es' || language === 'fr') return language;
  if (language === 'pt-BR' || language === 'pt-br') return 'pt-br';
  return '';
};

export const seoPathForLanguage = (pathname, language) => {
  if (!isSeoComparePath(pathname)) return null;
  const slug = stripSeoLocalePrefix(pathname);
  const prefix = pathPrefixForDisplayLanguage(language);
  return prefix ? `/${prefix}${slug}` : slug;
};

export const seoHrefForLanguage = (href, language, origin = window.location.origin) => {
  try {
    const url = new URL(href, origin);
    if (url.origin !== origin) return null;
    const nextPath = seoPathForLanguage(url.pathname, language);
    if (!nextPath) return null;
    if (nextPath === normalizePathname(url.pathname)) return null;
    url.pathname = nextPath;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};
